__webpack_require__.p = "/fhnw-styleguide-v5/_next/";